import { useSelector } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, StyledEngineProvider, CircularProgress } from '@mui/material';
import { useAuthenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

// routing
import Routes from 'routes';

// defaultTheme
import themes from 'themes';

// project imports
import NavigationScroll from 'layout/NavigationScroll';
import LoginCognito from 'views/pages/authentication/authentication3/LoginCognito';

// ==============================|| APP ||============================== //

const App = () => {
  const customization = useSelector((state) => state.customization);
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const navigate = useNavigate();

  useEffect(() => {
    if (authStatus === 'unauthenticated') {
      navigate('/login', { replace: true });
    }
  }, [authStatus, navigate]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes(customization)}>
        <CssBaseline />
        <NavigationScroll>
          {authStatus === 'configuring' && (
            <div style={{ textAlign: 'center', marginTop: '20px' }}>
              <CircularProgress />
              <p>Loading...</p>
            </div>
          )}
          {authStatus !== 'configuring' && authStatus !== 'authenticated' && <LoginCognito />}
          {authStatus === 'authenticated' && <Routes authStatus={authStatus} />}
        </NavigationScroll>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
